import { Icon, ICON_CHOICES } from "@/lib/icons";
import { labelFor } from "@/lib/labels";

export const COLOR_RE = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
export const IMAGE_KEYS = /(image|photo|poster|banner|logo|avatar|cover)/i;
const LONG_KEYS = /(para|desc|bio|quote|subheading|intro|about|message|subtitle|note|copyright)/i;

export default function Primitive({ fieldKey, value, onChange }) {
  if (typeof value === "boolean") {
    return (
      <label className="flex items-center gap-2 cursor-pointer">
        <input type="checkbox" checked={value} onChange={(e) => onChange(e.target.checked)} className="h-4 w-4 accent-[var(--c-primary)]" />
        <span className="text-sm text-stone-600">{labelFor(fieldKey)}</span>
      </label>
    );
  }

  if (fieldKey === "icon") {
    return (
      <div>
        <label className="block text-sm font-medium text-stone-600 mb-1.5">{labelFor(fieldKey)}</label>
        <div className="flex items-center gap-2">
          <span className="grid place-items-center h-9 w-9 rounded-lg border border-stone-200 text-[var(--c-primary)]">
            <Icon name={value} className="h-4 w-4" />
          </span>
          <select value={value || ""} onChange={(e) => onChange(e.target.value)} className="flex-1 rounded-lg border border-stone-200 px-3 py-2 text-sm">
            {!ICON_CHOICES.includes(value) && value ? <option value={value}>{value}</option> : null}
            {ICON_CHOICES.map((ic) => <option key={ic} value={ic}>{ic}</option>)}
          </select>
        </div>
      </div>
    );
  }

  if (typeof value === "string" && COLOR_RE.test(value)) {
    return (
      <div>
        <label className="block text-sm font-medium text-stone-600 mb-1.5">{labelFor(fieldKey)}</label>
        <div className="flex items-center gap-2">
          <input type="color" value={value} onChange={(e) => onChange(e.target.value)} className="h-9 w-12 rounded border border-stone-200 cursor-pointer" />
          <input value={value} onChange={(e) => onChange(e.target.value)} className="flex-1 rounded-lg border border-stone-200 px-3 py-2 text-sm font-mono" />
        </div>
      </div>
    );
  }

  const long = LONG_KEYS.test(fieldKey) || (typeof value === "string" && value.length > 70);
  return (
    <div>
      <label className="block text-sm font-medium text-stone-600 mb-1.5">{labelFor(fieldKey)}</label>
      {long ? (
        <textarea value={value || ""} onChange={(e) => onChange(e.target.value)} rows={3} className="w-full rounded-lg border border-stone-200 px-3 py-2 text-sm resize-y focus:outline-none focus:border-[var(--c-secondary)]" />
      ) : (
        <input value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="w-full rounded-lg border border-stone-200 px-3 py-2 text-sm focus:outline-none focus:border-[var(--c-secondary)]" />
      )}
    </div>
  );
}
